import ExportModal, { ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { LODGING_DOORS_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/LodgingDoors/LodgingDoorsColumnsInfo'

export default function LodgingDoorExportModal(props: ExportModalProps) {
  const dataTypeName = 'Lodging & Hospitality Doors'

  const lodgingColumnHelper = createExportColumnHelper({
    columns: LODGING_DOORS_COLUMNS,
  })

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        lodgingColumnHelper.retrieveColumn('name'),
        lodgingColumnHelper.retrieveColumn('chain_id'),
        lodgingColumnHelper.retrieveColumn('address'),
        lodgingColumnHelper.retrieveColumn('city'),
        lodgingColumnHelper.retrieveColumn('state'),
        lodgingColumnHelper.retrieveColumn('country'),
        lodgingColumnHelper.retrieveColumn('phone'),
        lodgingColumnHelper.retrieveColumn('website'),
        lodgingColumnHelper.retrieveColumn('reviews_avg'),
        lodgingColumnHelper.retrieveColumn('reviews_cnt'),
        lodgingColumnHelper.retrieveColumn('open_hours'),
        lodgingColumnHelper.retrieveColumn('chain_doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  return (
    <ExportModal
      title={`Select Columns for ${dataTypeName} Download`}
      subTitle={`Download up to 10,000 ${dataTypeName.toLocaleLowerCase()} at a time, with any of the following columns. Any filters already applied will remain active.`}
      submitText={`Export ${dataTypeName}`}
      columns={columns}
      {...props}
    />
  )
}
